import { ADMIN_OLD_CAMPAIGNS } from '../../types';

export default {
  state: {
    oldCampaignsQuery: null,
    campaignViewData: null,
  },
  getters: {
    oldCampaignsData(state) {
      if (!state.oldCampaignsQuery) {
        return null;
      }
      return state.oldCampaignsQuery.data || null;
    },
    campaignViewData(state) {
      return state.campaignViewData;
    },
  },
  mutations: {
    [ADMIN_OLD_CAMPAIGNS.SET_OLD_CAMPAIGNS_QUERY](state, payload) {
      state.oldCampaignsQuery = payload;
    },
    [ADMIN_OLD_CAMPAIGNS.SET_CAMPAIGN_VIEW_DATA](state, payload) {
      state.campaignViewData = payload;
    },
  },
  actions: {

  },

};
